import { useEffect, useState } from 'react'

export type Platform = 'android' | 'ios' | 'desktop'

export function detectPlatform(): Platform {
  if (typeof navigator === 'undefined') return 'desktop'
  const ua = navigator.userAgent
  if (/Android/i.test(ua)) return 'android'
  if (/iPhone|iPad|iPod/i.test(ua)) return 'ios'
  return 'desktop'
}

/** SSR-safe: renderiza como desktop e ajusta no cliente. */
export function usePlatform(): Platform {
  const [platform, setPlatform] = useState<Platform>('desktop')
  useEffect(() => {
    setPlatform(detectPlatform())
  }, [])
  return platform
}
